<template>
	<div>
		<flEditarVisualizar v-if="exibeStatus" :item="item" :editar="editar" @click-editar="(item) => $emit('click-editar', item)" />

		<div class="row" v-if="_existe(item.descricaoSubstituida)">
			<div class="col-md-12">
				<p style="color: red" v-if="item.descricaoSubstituida != null && item.descricaoSubstituida != ''">SUBSTÍTUIDA - NUMBER: {{item.descricaoSubstituida}}</p>
			</div>
		</div>

		<div class="row">
			<div class="col-md-9">

				<div class="row">

					<div class="col-4" v-if="_existe(item.taskNumber)">
						<p><small v-if="exibeLegenda" style="color: #777">(Task Number)<br/></small>{{item.taskNumber}} </p>
					</div>

					<div class="col-8" v-if="_existe(item.taskTitle)">
						<p><small v-if="exibeLegenda" style="color: #777">(Task Title)<br/></small>{{item.taskTitle}} </p>
					</div>
				</div>

				<div class="row">

					<div class="col-4">
						<small v-if="exibeLegenda && (_existe(item.refManual) || _existe(item.documentation))" style="color: #777">(Documentation)<br/></small>
						<p>{{item.refManual}} {{item.documentation}}</p>
					</div>

					<div class="col-8">
						<p><small v-if="exibeLegenda" style="color: #777">(Documentation Title)<br/></small>{{item.c3}} </p>
					</div>
				</div>

				<div class="row">

					<div class="col-12">
						<small v-if="exibeLegenda && _existe(item.c1)" style="color: #777">(Mod)<br/></small>
						<p v-if="item.c1 != null && item.c1 != ''">{{item.c1}}</p>
					</div>

					<div class="col-12">
						<small v-if="exibeLegenda && _existe(item.c6)" style="color: #777">(Level)<br/></small>
						<p v-if="item.c6 != null && item.c6 != ''">{{item.c6}}</p>
					</div>
				</div>

				<div class="row" v-if="_existe(item.c4)">
					<div class="col-md-12">
						<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Maintenance Tasks)<br/></small>{{item.c4}}</p>
					</div>
				</div>

				<div class="row" v-if="_existe(item.description)">
					<div class="col-md-12">
						<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Description)<br/></small>{{item.description}}</p>
					</div>
				</div>

				<div class="row" v-if="_existe(item.c5)">
					<div class="col-md-12">
						<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Remark)<br/></small>{{item.c5}}</p>
					</div>
				</div>

				<div class="row" v-if="_existe(item.c2)">
					<div class="col-md-12">
						<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Operating Condition)<br/></small>{{item.c2}}</p>
					</div>
				</div>

				<div class="row" v-if="_existe(item.c7)">
					<div class="col-md-12">
						<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Tipo / Item de Inspeção)<br/></small>{{item.c7}}</p>
					</div>
				</div>

			</div>

			<div class="col-md-3">
				<div class="row" style="margin-bottom:8px" v-show="!inps.excluir" v-for="(inps, idxIns) in item.inspecaoPeriodo" :key="idxIns">
					<div class="col-5">
						<small v-if="exibeLegenda" style="color: #777">(Limit)<br/></small>
						<span>{{inps.limit}} {{inps.unit}}</span>
						<span 	style="font-size: 10px; color: #1976D2"
								v-tooltip.center="'Tolerância'"
								v-if="inps.margin != 0">
							(+{{inps.margin}} {{inps.margin_unit}})
						</span>
					</div>

					<div class="col-7" v-if="inps.pnPeriodo.length > 0">
						<small v-if="exibeLegenda" style="color: #777">(PN)<br/></small>
						<div v-for="pns in inps.pnPeriodo" :key="pns.id + 'PN'" v-show="!pns.excluir"> {{pns.descricao}}</div>
					</div>
				</div>

				<div class="row">
					<div class="col-5" v-if="_existe(item.mpnInspecao)">
						<small v-if="exibeLegenda" style="color: #777">(MP/N)<br/></small>
						<div 	v-show="item.mpnInspecao != null && item.mpnInspecao.length > 0 && !it.excluir"
								v-for="(it, m) in item.mpnInspecao"
								:key="m + 'M'">
								{{it.descricao}}
						</div>
					</div>
					<div class="col-7" v-if="_existe(item.pnInspecao)">
						<small v-if="exibeLegenda" style="color: #777">(PN)<br/></small>
						<div 	v-show="item.pnInspecao != null && item.pnInspecao.length > 0 && !it.excluir"
								v-for="(it, m) in item.pnInspecao"
								:key="m + 'P'">
								{{it.descricao}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import flEditarVisualizar from './editar-visualizar.vue'
export default {

	components: {
		flEditarVisualizar
	},
	props: {
		item: {
			required: true,
			type: Object,
		},

		editar: {
			type: Boolean,
			required: false,
			default: true,
		},

		exibeLegenda: {
			required: true,
			type: Boolean,
		},

		exibeStatus: {
			type: Boolean,
			required: false,
			default: true,
		},
	}
}
</script>




// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/templates/SAFRAN_MM.vue